import { render, staticRenderFns } from "./searchTagResult.vue?vue&type=template&id=ef443284&scoped=true&"
import script from "./searchTagResult.vue?vue&type=script&lang=js&"
export * from "./searchTagResult.vue?vue&type=script&lang=js&"
import style0 from "./searchTagResult.vue?vue&type=style&index=0&id=ef443284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef443284",
  null
  
)

export default component.exports